import { GET } from './api'

export const ReadActiveCertificateTrainers = async () => GET('/certificate-trainers', true)
